import {useCustomLink} from "@composables/customLink";
import {AppType} from "@store/api/interfaces";

export function useVpnConnector() {

    const runVpnRoute = '/vpn/run/';

    const isRouteRunVpn = (): boolean => {
		return window.location.pathname.startsWith(runVpnRoute);
    }

    const customLink = useCustomLink();

    const getLinkOpen = (app: AppType) => {
        return window.location.origin + runVpnRoute + app;
    };

    const streisand = {
        open: () => {
            window.location.href = 'streisand://'
            //void customLink.open('streisand://');
        },
        connect: () => {
            window.location.href = 'streisand://connect'
            //void customLink.open('streisand://connect');
        },
        disconnect: () => {
            window.location.href = 'streisand://disconnect'
            //void customLink.open('streisand://disconnect');
        },
        import: (config: string) => {
            window.location.href = 'streisand://import/' + config
            //void customLink.open('streisand://import/' + config + '');
        }
    }

    const v2box = {
        open: () => {
            window.location.href = 'v2box://'
            //void customLink.open('v2box://');
        }
    }

    const hiddify = {
        open: () => {
            window.location.href = "hiddify://";
            //void customLink.open('hiddify://');
        }
    }

    const v2rayNg = {
        open: () => {
            window.location.href = "https://play.google.com/store/apps/details?id=com.v2ray.ang";
            //window.location.href = "intent://#Intent;package=com.v2ray.ang;action=android.intent.action.VIEW;end;";
            //void customLink.open('v2rayng://');
        }
    }


    return {
        streisand,
        v2box,
        hiddify,
        v2rayNg,
		isRouteRunVpn,
        getLinkOpen
    };
}
